import { useDispatch, useSelector } from "react-redux"
import { agregarFechaMesAgente, obtenerCotizcionesMensualesFechaAction } from "../../../ducks/reportesCotizacionesDuck"
import PickerMod from "../../../global/PickersMod"
import { esFechaValida } from "../../../utils/FormatFecha"

const FiltroMes = () => {
    const dispatch = useDispatch()
    const { fechaMes } = useSelector(store => store.reporteCotizador)
    const handleChangeFechaMes = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        dispatch(obtenerCotizcionesMensualesFechaAction({ fecha: date }))
        dispatch(agregarFechaMesAgente({mes: date}))
    }
    return (
        <PickerMod
            id="fechaFinalIngresos"
            label="Mes"
            selectedDate={fechaMes}
            setSelectedDate={handleChangeFechaMes}
            disablePast={false}
            disableFuture={true}
            formatFecha={"MM/yyyy"}
            views={["year", "month"]}
        />
    )
}
export default FiltroMes